import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router'
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 导入SvgIcon组件
import SvgIcon from '@/components/SvgIcon/index.vue' 
const req = require.context('@/assets/icons/svg', false, /\.svg$/)  
req.keys().map(req)
app.component('svg-icon', SvgIcon)
app.use(ElementPlus)
app.use(router)
app.mount('#app')
